export default "__VITE_ASSET__DBWSpG_U__"